import { generateKeyBetween, generateNKeysBetween } from 'fractional-indexing';

/**
 * Sortierschlüssel (Fractional Indexing). Jede Karte/Spalte hat einen String,
 * der lexikographisch sortiert wird. Ein Verschieben ändert im Normalfall nur
 * den Schlüssel des bewegten Elements.
 */
export function keyBetween(before: string | null | undefined, after: string | null | undefined): string {
  const a = before ?? null;
  const b = after ?? null;
  if (a !== null && b !== null && a >= b) {
    // Kollision (z. B. gleichzeitige Einfügungen): Aufrufer muss neu verteilen.
    throw new PositionCollisionError(a, b);
  }
  return generateKeyBetween(a, b);
}

export function keysBetween(before: string | null, after: string | null, n: number): string[] {
  return generateNKeysBetween(before, after, n);
}

export class PositionCollisionError extends Error {
  constructor(
    public readonly before: string,
    public readonly after: string,
  ) {
    super(`Positionskollision: ${before} >= ${after}`);
  }
}

/** Sortiert nach Position, bei Gleichstand stabil nach ID */
export function byPosition<T extends { position: string; id: string }>(a: T, b: T): number {
  if (a.position < b.position) return -1;
  if (a.position > b.position) return 1;
  return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
}
